// AudioContext.js
import React, { createContext, useContext } from 'react';
import OnDemandAlert from 'assets/audios/on-demand-alert.mp3';

const OnDemandAlertContext = createContext();

export const AudioProvider = ({ children }) => {
  const audio = new Audio(OnDemandAlert);

  const play = () => {
    audio.play();
  };

  const pause = () => {
    audio.pause();
  };

  return (
    <OnDemandAlertContext.Provider value={{ play, pause }}>
      {children}
    </OnDemandAlertContext.Provider>
  );
};

export const useAudio = () => useContext(OnDemandAlertContext);
